import * as yup from "yup";

const getBooleanValue = (value) => {
  if (value === "true" || value === true) {
    return true;
  }
  if (value === "false" || value === false) {
    return false;
  }
  return false;
};

export const populateForm = (value) => {
  return {
    id: value.id,
    // to: value.to,
    // cc: value.cc,
    // bcc: value.bcc,
    to: getConvertToEmailListSelectedOptions(value?.to),
    cc: getConvertToEmailListSelectedOptions(value?.cc),
    bcc: getConvertToEmailListSelectedOptions(value?.bcc),
    subject: value.subject,
    content: value.content,
    attachments: [],
    fromDate: value.fromDate,
    fromTime: value.fromTime,
    toDate: value.toDate,
    toTime: value.toTime,
    location: value.location,
    isVirtualMeeting: getBooleanValue(value.isVirtualMeeting),
    virtualMeetingLocation: value.virtualMeetingLocation,
    reminder: value.reminder,
    emailTemplateId: value.emailTemplateId,
  };
};

const getConvertToEmailListSelectedOptions = (emails) => {
  if (!emails) {
    return [];
  }
  const options = [];
  emails.forEach((element) => {
    options.push({ value: element, label: element });
  });
  return options;
};

export const initialValues = {
  id: null,
  to: [],
  cc: [],
  bcc: [],
  subject: "",
  content: "",
  attachments: [],
  fromDate: "",
  fromTime: "",
  toDate: "",
  toTime: "",
  location: "",
  isVirtualMeeting: false,
  virtualMeetingLocation: "",
  reminder: "",
  emailTemplateId: null,
};

export const generateSchema = () => {
  return yup.object().shape({
    id: yup.number().nullable().notRequired(),
    to: yup.array().min(1, "Input at least one email"),
    cc: yup.array().nullable().notRequired(),
    bcc: yup.array().nullable().notRequired(),
    subject: yup.string().required("Please enter a subject."),
    content: yup.string().required("Email can not be empty."),
    attachments: yup.array().nullable().notRequired(),
    fromDate: yup.string().required("Please enter a From Date."),
    fromTime: yup.string().required("Please enter a From Time."),
    toDate: yup.string().required("Please enter a To Date."),
    toTime: yup.string().required("Please enter a To Time."),
  });
};

export const schema = yup.object().shape({
  id: yup.number().nullable().notRequired(),
  to: yup.array().min(1, "Input at least one email"),
  cc: yup.array().nullable().notRequired(),
  bcc: yup.array().nullable().notRequired(),
  subject: yup.string().required("Please enter a subject."),
  content: yup.string().required("Email can not be empty."),
  attachments: yup.array().nullable().notRequired(),
  fromDate: yup.string().required("Please enter a From Date."),
  fromTime: yup.string().required("Please enter a From Time."),
  toDate: yup.string().required("Please enter a To Date."),
  toTime: yup.string().required("Please enter a To Time."),
});
